import { rqtPostAttachmentList, getFileUrl } from '@/services/common/attachment';
import { isImgUrl, isVideoUrl, isAudioUrl } from '@/utils/public/file';
import { rqtPostAttachmentFileUpload, rqtPostAttachmentBatchDelete } from '@/services/common/attachment';
export default {
  name: 'AttachmentCpt',
  /* props:{
    isUpload:{
      type: Boolean,
      default: true
    },
    isDelImage: {
      type: Boolean,
      default: true,
    }
  }, */
  data() {
    return {
      isUpload: true,
      isDelImage: true,
      show: false,
      routeArg: undefined,
      uploadFileList: [],
      // fileList: [],
      itemInfo: {},
      list: [],
      showImgPreview: false,
      preImages: []
    };
  },
  mounted() {},
  methods: {
    onDelImage(index) {
      rqtPostAttachmentBatchDelete(this.uploadFileList).then(() => {
        this.uploadFileList.splice(index, 1);
      }).catch(err => {
        console.error(err);
      });
    },
    previewImage(url) {
      this.showImgPreview = true;
      this.preImages = [url];
    },
    //弹出组件
    showComponent(data) {
      this.routeArg = data;
      this.show = true;
    },
    beforeReade(file) {
      this.uploadFileList = [...this.uploadFileList, file];
      return false;
    },
    //上传后的回调
    afterRead() {
      const {
        uploadFileList
      } = this;
      const formData = new FormData();
      uploadFileList.forEach(file => {
        formData.append('files', file.file);
      });
      const param = {
        businessId: this.itemInfo.businessId,
        attachmentType: this.itemInfo.attachmentType
      };
      formData.append('param', JSON.stringify(param));
      rqtPostAttachmentFileUpload(formData).then(() => {
        this.show = false;
      }).catch(err => {
        console.error(err);
      });
    },
    //删除已上传图片
    onBtnDeleteClick(elIndex) {
      let vm = this;
      const {
        uploadFileList
      } = this;
      rqtPostAttachmentBatchDelete([uploadFileList]).then(() => {
        return (file, name) => {
          console.log(file);
          let fileIndex = name.index;
          vm.uploadFileList[elIndex].splice(fileIndex, 1);
          vm.uploadFileList[elIndex].splice(fileIndex, 1);
        };
      }).catch(err => {
        console.error(err);
      });
    },
    showView(attachment) {
      this.itemInfo = {
        ...attachment
      };
      if (!this.itemInfo.businessId || !this.itemInfo.attachmentType) {
        throw 'attachment cpt has parameter error!';
      }
      let params = {
        businessId: this.itemInfo.businessId,
        attachmentType: this.itemInfo.attachmentType
      };
      rqtPostAttachmentList(params).then(res => {
        const resData = res.data.data;
        this.uploadFileList = resData;
      }).catch(err => {
        console.error(err);
      });
    },
    onImgClick(url) {
      this.preImages = [url];
      this.showImgPreview = true;
    },
    isImgUrl,
    isVideoUrl,
    isAudioUrl,
    getFileUrl
  }
};